import { render, staticRenderFns } from "./ChoixAccueil.vue?vue&type=template&id=12dfa476"
import script from "./ChoixAccueil.vue?vue&type=script&lang=js"
export * from "./ChoixAccueil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports